import React, { memo, useCallback, useState, useEffect } from 'react'
import { useTranslation, Trans } from 'react-i18next'
import { Row, Col, Input, Form, Select, Checkbox, Button } from 'antd'
import { useMutation, useQuery } from '@apollo/react-hooks'
import { toast } from 'react-toastify'
import classNames from 'classnames'

import classes from './styles.module.scss'
import {
	StoreValue,
	GetUniversities,
	GetFaculties,
	GetFacultySpecializations,
	RoLocations,
	AddStudentKit,
	RegisterMutation,
} from 'store'
import { useDebounce } from 'utils'
import { ModalTermsAndConditions } from 'components'

const { Option } = Select

const universitiesToBeHidden: string[] = []

const universityLevels = [
	{
		label: 'Licenta an 1',
		value: 'Licenta_an_1',
	},
	{
		label: 'Licenta an 2',
		value: 'Licenta_an_2',
	},
	{
		label: 'Licenta an 3',
		value: 'Licenta_an_3',
	},
	{
		label: 'Licenta an 4',
		value: 'Licenta_an_4',
	},
	{
		label: 'Licenta an 5',
		value: 'Licenta_an_5',
	},
	{
		label: 'Licenta an 6',
		value: 'Licenta_an_6',
	},
	{
		label: 'Masterat',
		value: 'Masterat',
	},
	{
		label: 'Doctorat',
		value: 'Doctorat',
	},
]

const RegisterForm: React.FunctionComponent<any> = ({ handleRegistration }) => {
	const [termsAndConditionsModal, setTermsAndConditionsModal] =
		useState(false)
	const [termsAndConditionsCheckbox, setTermsAndConditionsCheckox] =
		useState(false)
	const [registerMutationHandle] = useMutation(RegisterMutation)

	const toggleTermsAndConditionsModal = useCallback(
		event => {
			event.preventDefault()
			setTermsAndConditionsModal(!termsAndConditionsModal)
		},
		[termsAndConditionsModal],
	)

	const toggleTermsAndConditionsCheckbox = useCallback(() => {
		setTermsAndConditionsCheckox(!termsAndConditionsCheckbox)
	}, [termsAndConditionsCheckbox])

	const handleAgreement = useCallback(
		(agreement: boolean) => {
			setTermsAndConditionsModal(false)
			setTermsAndConditionsCheckox(agreement)
		},
		[setTermsAndConditionsModal, setTermsAndConditionsCheckox],
	)

	const { i18n } = useTranslation()
	const t = i18n.getFixedT('ro')
	const [universityId, setUniversityId] = useState('')
	const [facultyId, setFacultyId] = useState('')
	const [, setFacultySpecializationId] = useState('')
	const [searchFacultyText, setSearchFacultyText] = useState('')
	const [searchLocationText, setSearchLocationText] = useState('')
	const [
		searchFacultySpecializationsText,
		setSearchFacultySpecializationsText,
	] = useState('')
	const [searchFacultyLoading, setSearchFacultyLoading] = useState(false)
	const [searchLocationLoading, setSearchLocationLoading] = useState(false)
	const [, setSearchFacultySpecializationsLoading] = useState(false)
	const [facultiesResult, setFacultiesResult] = useState([])
	const [locationResult, setLocationResult] = useState([])
	const [facultySpecializationsResult, setFacultySpecializationsResult] =
		useState([])
	const debouncedSearchFacultyText = useDebounce(searchFacultyText, 500)
	const debouncedSearchLocationText = useDebounce(searchLocationText, 500)
	const debouncedSearchFacultySpecializatonsText = useDebounce(
		searchFacultySpecializationsText,
		500,
	)
	const [addStudentKitMutation] = useMutation(AddStudentKit)
	const {
		data: universitiesData,
	}: //loading: getUniversitiesLoading,
	any = useQuery(GetUniversities, { fetchPolicy: 'cache-first' })

	const {
		//data: facultiesData,
		//loading: getFacultiesLoading,
		refetch: getFacultiesRefetch,
	}: any = useQuery(GetFaculties, {
		// skip: true,
		fetchPolicy: 'cache-first',
	})
	const {
		//data: roLocations,
		//loading: roLocationsLoading,
		refetch: getRoLocationsRefetch,
	}: any = useQuery(RoLocations, {
		// skip: true,
		fetchPolicy: 'cache-first',
	})

	const {
		// data: facultySpecializationsData,
		// loading: getFacultySpecialization,
		refetch: getFacultySpecializationsRefetch,
	}: any = useQuery(GetFacultySpecializations, {
		// skip: true,
	})

	const handleChangeUniversity = useCallback((universityId: string) => {
		setUniversityId(universityId)
	}, [])

	const handleSearchFaculties = useCallback((faculty: string) => {
		setSearchFacultyText(faculty)
	}, [])

	const handleSelectFaculty = useCallback((facultyId: string) => {
		setFacultyId(facultyId)
	}, [])

	const handleSearchFacultySpecializations = useCallback(
		(facultySpecialization: string) => {
			setSearchFacultySpecializationsText(facultySpecialization)
		},
		[],
	)

	const handleSelectFacultySpecialization = useCallback(
		(facultySpecializationId: string) => {
			setFacultySpecializationId(facultySpecializationId)
		},
		[],
	)

	const handleSearchLocation = useCallback((location: string) => {
		setSearchLocationText(location)
	}, [])

	const handleSelectLocation = useCallback((location: string) => {}, [])

	const onFinish = useCallback(
		async (values: {
			firstName: string
			lastName: string
			email: string
			facultyId: string
			specializationId: string
			locationId: string
			universityLevel: any
			universityId: string
			password: string
			confirmPassword: string
		}) => {
			const { password, confirmPassword, ...studentKitInputData } = values

			await addStudentKitMutation({
				variables: {
					data: {
						...studentKitInputData,
						language: i18n.language,
					},
				},
			})
				.then(response => {
					const { firstName, lastName, email } =
						response.data.addStudentKit

					registerMutationHandle({
						variables: {
							data: {
								firstName,
								lastName,
								email,
								password,
								language: i18n.language,
								sendConfirmEmail: false,
							},
						},
					})

					handleRegistration()
				})
				.catch(error => {
					toast.error(t('Registration failed'), {
						position: 'top-center',
						autoClose: 5000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
					})
				})
		},
		[
			addStudentKitMutation,
			handleRegistration,
			t,
			registerMutationHandle,
			i18n.language,
		],
	)

	useEffect(() => {
		if (debouncedSearchFacultyText) {
			setSearchFacultyLoading(true)
			const fetch = async () => {
				const result = await getFacultiesRefetch({
					universityId: universityId,
					facultyName: debouncedSearchFacultyText,
				})

				setFacultiesResult(result.data.getFaculties)
				setSearchFacultyLoading(false)
			}
			fetch()
		} else {
			setFacultiesResult([])
		}
	}, [debouncedSearchFacultyText, getFacultiesRefetch, universityId])

	useEffect(() => {
		if (debouncedSearchFacultySpecializatonsText) {
			setSearchFacultySpecializationsLoading(true)
			const fetch = async () => {
				const result = await getFacultySpecializationsRefetch({
					facultyId: facultyId,
					specializationName:
						debouncedSearchFacultySpecializatonsText,
				})

				setFacultySpecializationsResult(
					result.data.getFacultySpecializations,
				)
				setSearchFacultySpecializationsLoading(false)
			}
			fetch()
		} else {
			setFacultySpecializationsResult([])
		}
	}, [
		debouncedSearchFacultySpecializatonsText,
		getFacultySpecializationsRefetch,
		facultyId,
	])

	useEffect(() => {
		if (debouncedSearchLocationText) {
			setSearchLocationLoading(true)
			const fetch = async () => {
				const result = await getRoLocationsRefetch({
					data: {
						name: debouncedSearchLocationText,
						emptyResult: true,
						limitRows: 10,
						type_in: [
							'Comună',
							'Oraş',
							'Municipiu',
							'National capital',
							'Sectoarele municipiului',
						],
					},
				})
				setLocationResult(result?.data?.roLocations)
				setSearchLocationLoading(false)
			}
			fetch()
		} else {
			setLocationResult([])
		}
	}, [debouncedSearchLocationText, getRoLocationsRefetch])

	return (
		<>
			<Form
				name="student_kit"
				initialValues={{ remember: true }}
				onFinish={onFinish}
				//onFinishFailed={onFinishFailed}
			>
				<div className={classes.container}>
					<Row className={classes.row} gutter={8}>
						<Col className={classes.column} xs={24} md={12}>
							<Form.Item
								name="firstName"
								rules={[
									{
										required: true,
										message: t(
											'Please enter your first name',
										),
									},
								]}
								requiredMark={true}
							>
								<Input
									id="firstName"
									type={'text'}
									placeholder={t('First Name')}
								/>
							</Form.Item>
						</Col>

						<Col className={classes.column} xs={24} md={12}>
							<Form.Item
								name="lastName"
								requiredMark={true}
								rules={[
									{
										required: true,
										message: t(
											'Please enter your last name',
										),
									},
								]}
							>
								<Input
									id="lastName"
									type={'text'}
									placeholder={t('Last Name')}
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row className={classes.row} gutter={8}>
						<Col className={classes.column} xs={24} md={12}>
							<Form.Item
								name="email"
								requiredMark={true}
								rules={[
									{
										type: 'email',
										required: true,
										message: t('Please enter your email'),
									},
								]}
							>
								<Input
									id="email"
									type={'email'}
									placeholder={t('Email')}
								/>
							</Form.Item>
						</Col>
						<Col className={classes.column} xs={24} md={12}>
							<>
								<Form.Item
									style={{ marginBottom: 0 }}
									name="universityId"
									requiredMark={true}
									rules={[
										{
											required: true,
											message: t(
												'Please select your university',
											),
										},
									]}
								>
									<Select
										className={classes.select}
										onChange={handleChangeUniversity}
										placeholder={t('University')}
									>
										{universitiesData?.getUniversities
											.filter(
												(item: { name: string }) =>
													!universitiesToBeHidden.includes(
														item.name,
													),
											)
											.map(
												(item: {
													id: string
													name: string
												}) => {
													return (
														<Option
															key={`university-${item.id}`}
															value={item.id}
														>
															{item.name}
														</Option>
													)
												},
											)}
									</Select>
								</Form.Item>
								{/* <div style={{ fontSize: 12, color: 'grey' }}>
									{`*${t(
										'Students Kit 2021 is available only in the universities listed.',
									)}`}
								</div> */}
							</>
						</Col>
					</Row>
					<Row className={classes.row} gutter={8}>
						<Col className={classes.column} xs={24} md={12}>
							<Form.Item
								name={'facultyId'}
								rules={[
									{
										required: true,
										message: t('Please enter your faculty'),
									},
								]}
							>
								<Select
									showSearch
									className={classes.autocomplete}
									onSelect={handleSelectFaculty}
									onSearch={handleSearchFaculties}
									placeholder={t('Faculty')}
									loading={searchFacultyLoading}
									filterOption={(input, option: any) =>
										option.children
											.toLowerCase()
											.indexOf(input.toLowerCase()) >= 0
									}
									dropdownRender={menu => (
										<div>
											{menu?.props?.options?.length >
											0 ? (
												menu
											) : (
												<div
													style={{
														display: 'flex',
														flexWrap: 'nowrap',
														padding: 8,
													}}
												>
													{t(
														'Start typing to see the list',
													)}
												</div>
											)}
										</div>
									)}
								>
									{facultiesResult.map(
										(item: {
											id: string
											name: string
										}) => {
											return (
												<Option
													key={`faculty-${item.id}`}
													value={item.id}
												>
													{item.name}
												</Option>
											)
										},
									)}
								</Select>
							</Form.Item>
						</Col>
						<Col className={classes.column} xs={24} md={12}>
							<Form.Item
								name={'specializationId'}
								rules={[
									{
										required: false,
										message: t(
											'Please enter your specialization',
										),
									},
								]}
							>
								<Select
									showSearch
									className={classes.autocomplete}
									onSelect={handleSelectFacultySpecialization}
									onSearch={
										handleSearchFacultySpecializations
									}
									placeholder={t('Specialization')}
									loading={searchFacultyLoading}
									filterOption={(input, option: any) =>
										option.children
											.toLowerCase()
											.indexOf(input.toLowerCase()) >= 0
									}
									dropdownRender={menu => (
										<div>
											{menu?.props?.options?.length >
											0 ? (
												menu
											) : (
												<div
													style={{
														display: 'flex',
														flexWrap: 'nowrap',
														padding: 8,
													}}
												>
													{t(
														'Start typing to see the list',
													)}
												</div>
											)}
										</div>
									)}
								>
									{facultySpecializationsResult.map(
										(item: {
											id: string
											name: string
										}) => {
											return (
												<Option
													key={`facultySpecialization-${item.id}`}
													value={item.id}
												>
													{item.name}
												</Option>
											)
										},
									)}
								</Select>
							</Form.Item>
						</Col>
					</Row>
					<Row className={classNames(classes.row)} gutter={8}>
						<Col className={classes.column} xs={24} md={12}>
							<Form.Item
								name="universityLevel"
								rules={[
									{
										required: true,
										message: t(
											'Please select your university level',
										),
									},
								]}
							>
								<Select placeholder={t('Year')}>
									{universityLevels.map(
										(
											item: {
												label: string
												value: string
											},
											index: number,
										) => {
											return (
												<Option
													key={`universityLevel-${index}`}
													value={item.value}
												>
													{item.label}
												</Option>
											)
										},
									)}
								</Select>
							</Form.Item>
						</Col>
						<Col className={classes.column} xs={24} md={12}>
							<Form.Item
								name={'locationId'}
								rules={[
									{
										required: true,
										message: t('Please enter the location'),
									},
								]}
							>
								<Select
									showSearch
									className={classes.autocomplete}
									onSelect={handleSelectLocation}
									onSearch={handleSearchLocation}
									placeholder={t('City of residence')}
									loading={searchLocationLoading}
									filterOption={(input, option: any) =>
										option.children
											.toLowerCase()
											.indexOf(input.toLowerCase()) >= 0
									}
									dropdownRender={menu => (
										<div>
											{menu?.props?.options?.length >
											0 ? (
												menu
											) : (
												<div
													style={{
														display: 'flex',
														flexWrap: 'nowrap',
														padding: 8,
													}}
												>
													{t(
														'Start typing to see the list',
													)}
												</div>
											)}
										</div>
									)}
								>
									{locationResult.map(
										(item: {
											id: string
											name: string
										}) => {
											return (
												<Option
													key={`location-${item.id}`}
													value={item.id}
												>
													{item.name}
												</Option>
											)
										},
									)}
								</Select>
							</Form.Item>
						</Col>
					</Row>
					<Row className={classes.row} gutter={8}>
						<Col className={classes.column} xs={24} md={12}>
							<Form.Item
								name="password"
								rules={[
									{
										required: true,
										message: t(
											'Please enter your password',
										),
									},
								]}
								requiredMark={true}
							>
								<Input.Password placeholder={t('Password')} />
							</Form.Item>
						</Col>

						<Col className={classes.column} xs={24} md={12}>
							<Form.Item
								name="confirmPassword"
								requiredMark={true}
								dependencies={['password']}
								rules={[
									{
										required: true,
										message: t(
											'Please confirm your password',
										),
									},
									({ getFieldValue }) => ({
										validator(rule, value) {
											if (
												!value ||
												getFieldValue('password') ===
													value
											) {
												return Promise.resolve()
											}

											return Promise.reject(
												t(
													'The two passwords that you entered do not match!',
												),
											)
										},
									}),
								]}
							>
								<Input.Password
									placeholder={t('Confirm Password')}
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row className={classes.row} gutter={8}>
						<Col className={classes.column} span={24}>
							<div className={classes.termsAndConditions}>
								<Trans i18nKey="TermsAndConditionsLabel">
									<Checkbox
										onChange={
											toggleTermsAndConditionsCheckbox
										}
										checked={termsAndConditionsCheckbox}
									>
										I read and I agree to the
									</Checkbox>
									<span
										className={
											classes.termsAndConditionsModal
										}
										onClick={event =>
											toggleTermsAndConditionsModal(event)
										}
									>
										Terms and conditions
									</span>
								</Trans>
							</div>
						</Col>
					</Row>
					<Row className={classes.row}>
						<Col className={classes.column} span={24}>
							<div className={classes.divBottomInfoText}>
								{t(
									'Avand in vedere situatia generata de Covid, in programul campaniei pot aparea modificari ale locatiilor si/sau datelor de distributie. Vom comunica prin email update-urile pe masura ce apar. Pentru sugestii/intrebari, scrie-ne pe contact@cv30.co',
								)}
							</div>
						</Col>
					</Row>
					<Row className={classes.row} gutter={8}>
						<Col className={classes.column} span={24}>
							<div
								className={classNames(classes.saveButton, {
									[classes.disabledSaveButton]:
										!termsAndConditionsCheckbox,
								})}
							>
								<Button
									htmlType={'submit'}
									type="primary"
									disabled={!termsAndConditionsCheckbox}
								>
									{t('Save')}
								</Button>
							</div>
						</Col>
					</Row>
				</div>
			</Form>
			<ModalTermsAndConditions
				handleAgreement={handleAgreement}
				termsAndConditionsModal={termsAndConditionsModal}
			/>
		</>
	)
}

export default memo((props: any) => (
	<StoreValue keys={['user|storeUser']}>
		<RegisterForm {...props} />
	</StoreValue>
))
